import $ from "jquery";

let mapMarker = $('.agencies-map__marker');
let agencies = $('.agencies-map__single');

agencies.each(function() {
    $(this).on('mouseenter', function() {
        let location = $(this).attr('data-location');
        mapMarker.each(function() {
            if($(this).attr('data-location') === location) {
                $(this).addClass('active');
            }  
        });
    });
    $(this).on('mouseleave', function() {
        let location = $(this).attr('data-location');
        mapMarker.each(function() {
            if($(this).attr('data-location') === location) {
                $(this).removeClass('active');
            }  
        });
    });
});
